import styled from 'styled-components';

export const ScaledIcon = styled.svg`
  transform: scale(1.1);
`;
